import React, { useState } from "react";
import * as theme from '../../../theme';
import Heading from "../../../components/Heading";

function ImprintFAQs() {
  // State to manage which FAQ is open (null means all closed)
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ answer visibility
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  // FAQ data
  const faqs = [
    {
      question: "What happens if I forget to take a dose?",
      answer: "Missing a dose is not harmful, but it may slow the process of clearing imbalances in your body. Take the missed dose as soon as possible. If it's near bedtime and you've forgotten all day, take only the single dose for that day. Avoid doubling up on doses, as this could trigger a detox reaction."
    },
    {
      question: "What if I just ate and can't wait to take the imprint?",
      answer: "Ideally, wait at least 30 seconds after eating before taking the imprint. However, if waiting would cause you to miss a dose, it's better to take the imprint than skip it entirely, regardless of recent food or drink consumption."
    },
    {
      question: "Should I expect significant changes, or what if I don't notice any changes?",
      answer: "The imprint remedy provides information to gently balance your body, often resulting in subtle changes that build over time. Most clients notice the best results after their second, third, or fourth imprint remedy. The longer an imbalance has persisted, the more 'layers' your body may need to address, similar to peeling an onion. Children typically respond faster, but results vary based on the duration of the imbalance."
    },
    {
      question: "I experienced strong detox effects with the imprint remedy. Will this happen every time?",
      answer: "Detox reactions are uncommon, and even if they occur with the initial imprint remedy, they are rare with subsequent remedies. A detox reaction indicates your body is processing significant imbalances, suggesting a need to reduce the dose or frequency temporarily. After the first remedy, your body typically clears enough layers that future detox reactions are unlikely."
    }
  ];

  return (
    <div style={{ position: 'relative', marginTop: 10, marginRight: 'auto', marginLeft: 'auto', width: '100%', boxSizing: 'border-box' }}>
      <Heading
        title={'FREQUENTLY ASKED QUESTIONS'}
        subHeading={true}
        center={true}
      />
      {faqs.map((faq, index) => (
        <div
          key={index}
          style={{
            marginBottom: 16,
            borderBottom: `1px solid ${theme.Colors.GoldDark}`,
            width: window.innerWidth > 1200 ? 800 : '100%',
            boxSizing: 'border-box'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              padding: '8px 16px',
              ...theme.SubText,
              fontWeight: '600',
              width: window.innerWidth > 1200 ? 800 : '100%',
              boxSizing: 'border-box',
              margin: 0 // Override any inherited margins
            }}
            onClick={() => toggleFaq(index)}
          >
            <span style={{ flex: 1, marginRight: 8 }}>{faq.question}</span>
            <span style={{ fontSize: '1.2em', transition: 'transform 0.2s', flexShrink: 0 }}>
              {openFaq === index ? '↑' : '↓'}
            </span>
          </div>
          {openFaq === index && (
            <div
              style={{
                ...theme.SubText,
                padding: '8px 16px',
                backgroundColor: theme.Colors.GoldLight,
                width: window.innerWidth > 1200 ? 800 : '100%',
                boxSizing: 'border-box'
              }}
            >
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default ImprintFAQs;